import React from 'react'
import styled from '@emotion/styled'
import { ContentContainer } from 'components'
import { Icon } from 'antd'
import { colors, elements } from 'style/theme'
import { MoreItems } from 'components'

const StyledScansInfo = styled.div({
	display: 'grid',
	gridTemplateColumns: '1fr 40px',
	gridColumnGap: 5,
})

const Info = styled.div({
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: '1rem'
})

const InfoItem = styled.div(props => ({
	display: 'block',
	alignItems: 'center',
	textAlign: props.textAlign || 'left'
}))

const InfoItemLabel = styled.div({
	marginRight: 10,
	fontSize: 9,
	fontWeight: 700,
	display: 'block'
})

const InfoItemValue = styled.div({
	fontWeight: 700,
	color: colors.brand,
})

const ScansInfo = ({ data = {}, loading }) => {
	const { name, cookies, labels, webhooks, restrictions, type, pre_flow, rules, count } = data
	return (
		<ContentContainer pad={false}>
				<StyledScansInfo>
					<Info>
						<InfoItem>
							<InfoItemLabel>NAME</InfoItemLabel>
							<InfoItemValue>{name}</InfoItemValue>
						</InfoItem>
						<InfoItem>
							<InfoItemLabel>TYPE</InfoItemLabel>
							<InfoItemValue>{type}</InfoItemValue>
						</InfoItem>
						<InfoItem textAlign="center">
							<InfoItemLabel>PAGE COUNT</InfoItemLabel>
							{ count ? <InfoItemValue>{count}</InfoItemValue> : <span>-</span> }
						</InfoItem>
						<InfoItem>
							<InfoItemLabel>PRE FLOW</InfoItemLabel>
							{pre_flow ? <InfoItemValue>{pre_flow}</InfoItemValue> : <span>-</span>}
						</InfoItem>
						<InfoItem>
							<InfoItemLabel>RESTRICTIONS</InfoItemLabel>
							{restrictions && restrictions.length ? <MoreItems items={restrictions} placement="right" /> : <span>-</span>}
						</InfoItem>
						<InfoItem>
							<InfoItemLabel>LABELS</InfoItemLabel>
							{labels && labels.length ? <MoreItems items={labels} placement="right" /> : <span>-</span>}
						</InfoItem>
						<InfoItem>
							<InfoItemLabel>COOKIES</InfoItemLabel>
							{cookies && cookies.length ? <MoreItems items={cookies} placement="bottom" /> : <span>-</span>}
						</InfoItem>
						<InfoItem>
							<InfoItemLabel>WEBHOOKS</InfoItemLabel>
							{webhooks && webhooks.length ? <MoreItems items={webhooks} placement="bottom" /> : <span>-</span>}
						</InfoItem>
						<InfoItem>
							<InfoItemLabel>RULES</InfoItemLabel>
							{rules && rules.length ? <MoreItems items={rules} placement="bottom" /> : <span>-</span>}
						</InfoItem>
					</Info>
				</StyledScansInfo>
		</ContentContainer>
	)
}

export default ScansInfo
